import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { IUnitCard } from '../../activity/user-card.interface';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/utils/common.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

@Component({
  selector: 'app-view-all-shared-access',
  templateUrl: './view-all-shared-access.component.html',
  styleUrls: ['./view-all-shared-access.component.scss'],
})
export class ViewAllSharedAccessComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;
  sharedData!: any;
  siteId!: string;
  sharedAccess: IUnitCard[] = [];
  subscription: Subscription | undefined;
  commonAccessControl!: boolean;

  constructor(
    public dialogRef: MatDialogRef<ViewAllSharedAccessComponent>,
    private dashboardManagementService: DashboardManagementService,
    @Inject(MAT_DIALOG_DATA) data: any,
    private notificationService: NotificationService,
    public sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService,
    private stateManagementService: StateManagementService
  ) {
    this.siteId = data?.siteId;
  }
  ngOnInit(): void {
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    this.subscription = this.sharedDataService?.currentData?.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
    this.dashboardManagementService
      .getDashboardSharedAccess(this.siteId)
      .subscribe({
        next: (res: any) => {
          this.sharedAccess = res?.sharedAccesses[0]?.access;
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('getDashboardSharedAccess', err);
          this.notificationService.showError(err?.message);
        },
      });
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * Handle the click event when accessing a specific resource.
   * @param access - The access object representing the resource.
   */
  onClickAccess(access: any) {
    // Set the selected building, floor, and access point or unit data
    this.sharedDataService.setAllEntityData(access);
    this.closeDialog();

    // Navigate to the site management page
    this.router.navigate(['../site-management']);
  }
}
